import { Module, ActionTree, MutationTree, GetterTree } from 'vuex';

const initialState: SearchState = {
    results: { Meta: { Page: 0, ResultsPerPage: 20, TotalPages: 0, TotalResults: 0 }, Results: [] },
};

const rootState: SearchState = initialState;

const getters: GetterTree<SearchState, RootState> = {
    results(state: SearchState): FvgDossierSearchResults | undefined {
        return state.results;
    },
};

const mutations: MutationTree<SearchState> = {
    RESET(state: SearchState) {
        Object.assign(state, initialState);
    },
    SET_RESULTS(state: SearchState, results: FvgDossierSearchResults) {
        state.results = results;
    },
    ADD_RESULTS(state: SearchState, results: FvgDossierSearchResults) {
        state.results.Meta = results.Meta;

        state.results.Results = state.results.Results.concat(results.Results);
    },
};

const actions: ActionTree<SearchState, RootState> = {
    all({ commit }, payload: object): any {
        // @ts-ignore
        return this._vm.$api.get('search', { params: payload })
            .then((data: ApiResponseSearch) => {
                // @ts-ignore
                if (!payload.page) {
                    commit('SET_RESULTS', data.data);
                } else {
                    commit('ADD_RESULTS', data.data);
                }
                return Promise.resolve(data.data);
            })
            .catch((e: any) => {
                return Promise.reject([e.response.data]);
            });
    },
};

export default {
    namespaced: true,
    state: rootState,
    getters,
    actions,
    mutations,
};
